export default __webpack_public_path__ + "static/media/envelope.f071e4d8.svg";